module.exports = __webpack_public_path__ + "img/prophasud-logo.0e4c36ce.png";